module.exports = __webpack_public_path__ + "static/media/src_image_vip_icon_youshengxiaoshuo.458ee432.png";